import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { isPartner } from "@shared/utils/brand-utils";
import { KeycloakService } from "keycloak-angular";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../../../environments/environment";
import { AuthenticationService } from "../services/authentication.service";
import { MsalAuthenticationService } from "@shared/services/msal-authentication.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private readonly msalAuthenticationService: MsalAuthenticationService
  ) {}

  //! We need to make an exception for some calls
  allowAnonymous = ["api/payment/"];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiUrl = request.url.startsWith(environment.apiConfig.uri);

    // Pour les conseillers en mode SSO : ne pas ajouter de token d'authentification
    if (this.msalAuthenticationService.isAdvisorSsoEntry() && isApiUrl) {
      return next.handle(request);
    }

    // Pour les marques partenaires: HM, MGEN, MNT : utiliser Keycloak
    if (isPartner(environment) && isApiUrl && !this.allowAnonymous.some(route => request.url.includes(route))) {
      const keycloak = inject(KeycloakService);
      const token = keycloak.getKeycloakInstance().token;

      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    }

    // Pour les autres marques : utiliser AuthenticationService
    else {
      const token = this.authenticationService.tokenValue.value;

      if (token && isApiUrl) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}
